import type { IconData } from '@stacksjs/iconify-core'

export const visualStudio: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.133 14.242L4.2 18.087l-2.152-1.072V6.994l2.144-1.08l4.9 3.853L16.849 2l5.104 2.033v15.9L16.875 22Zm7.563 1.352V8.406l-4.645 3.598zM4.369 14.301l2.442-2.22l-2.442-2.433Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default visualStudio
